import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiHome } from 'react-icons/fi';

const pageVariants = {
  initial: { opacity: 0, x: 40 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -40 },
};

const NotFoundPage = () => (
  <motion.div
    variants={pageVariants}
    initial="initial"
    animate="animate"
    exit="exit"
    transition={{ duration: 0.35 }}
    className="min-h-[70vh] flex items-center justify-center bg-white dark:bg-dark-100 transition-colors duration-300"
  >
    <div className="text-center px-4">
      <h1 className="text-8xl md:text-9xl font-bold gradient-text mb-4">404</h1>
      <h2 className="text-2xl md:text-3xl font-bold text-secondary-800 dark:text-white mb-4">
        Page Not Found
      </h2>
      <p className="text-lg text-secondary-600 dark:text-gray-100 mb-8 max-w-md mx-auto">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 px-8 py-3 bg-primary-600 text-white rounded-lg font-medium hover:bg-primary-700 transition-colors duration-200"
      >
        <FiHome className="w-4 h-4" /> Back to Home
      </Link>
    </div>
  </motion.div>
);

export default NotFoundPage;
